import Immutable from 'immutable';
import {
  IntegrationsFile,
  RawIntegrationsFile,
} from 'records/IntegrationsFile';
import {
  IntegrationsFolderMetadata,
  RawIntegrationsFolderMetadata,
} from 'records/IntegrationsFolderMetadata';

export interface RawIntegrationsFolder {
  id: string;
  metadata: RawIntegrationsFolderMetadata;
  items: {
    folders: RawIntegrationsFolderMetadata[];
    documents: RawIntegrationsFile[];
  };
}

export interface IntegrationsFolderData {
  id: string;
  metadata: IntegrationsFolderMetadata;
  items: {
    folders: Immutable.List<IntegrationsFolderMetadata>;
    documents: Immutable.List<IntegrationsFile>;
  };
}

const defaultValues: IntegrationsFolderData = {
  id: '',
  metadata: new IntegrationsFolderMetadata(),
  items: {
    folders: Immutable.List<IntegrationsFolderMetadata>(),
    documents: Immutable.List<IntegrationsFile>(),
  },
};

export const IntegrationsFolderFactory = Immutable.Record(
  defaultValues,
  'IntegrationsFolder'
);

export class IntegrationsFolder extends IntegrationsFolderFactory {
  static deserialize(
    rawIntegrationsFolder: RawIntegrationsFolder
  ): IntegrationsFolder {
    const { id, metadata, items } = rawIntegrationsFolder;
    const { folders, documents } = items;

    return new IntegrationsFolder({
      id,
      metadata: IntegrationsFolderMetadata.deserialize(metadata),
      items: {
        folders: Immutable.List<IntegrationsFolderMetadata>(
          folders.map(IntegrationsFolderMetadata.deserialize)
        ),
        documents: Immutable.List<IntegrationsFile>(
          documents.map(IntegrationsFile.deserialize)
        ),
      },
    });
  }

  serialize(): RawIntegrationsFolder {
    return this.toJS();
  }
}
